import Vue from "vue";
import promise from "es6-promise";
promise.polyfill();
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/reset.css";
import "./styles/kuafu.scss"
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import tool from "./utils/tool";
Vue.use(tool);
/*适配*/
// import "./utils/lib/rem";
// ===动态改变标题
import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
// ===增添meta
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);
/* 图片懒加载 */
// ****记住要引入assets里的图片要用require(),不仅在.vue文件的js部分要用require引入
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  error: require("@/assets/default.png"),
  loading: require("@/assets/default.png")
});
/* 无缝滚动 */
import scroll from "vue-seamless-scroll";
Vue.use(scroll);
/* 挂在全局组件 */
import comments from "@/components/components.js";
Vue.use(comments);

/*google账户*/
import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)
// minxin
import index from './mixins/index'
Vue.mixin(index)

import preventReClick from '@/utils/preventReClick'
Vue.use(preventReClick)

import '@/utils/static/lib-flexible'
import '@/utils/static/lib-flexible/flexible.js'

import vueFabricSketchpad from '../packages/sketchpad'
Vue.use(vueFabricSketchpad)
if (process.env.VUE_APP_TITLE === "prod") {
  Vue.prototype.pro = true;
} else {
  Vue.prototype.pro = false;
}
/* qs */
import qs from "qs";
Vue.prototype.qs = qs;
Vue.config.productionTip = false;
/* 语言切换*/
import {i18n} from './i18n/index.js'
// 语言切换的方法
import {translate} from '@/i18n/index.js'
Vue.prototype.$lang = translate;
new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  /* //添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  } */
}).$mount("#app");
